import { useMemo } from "react";
import { useAppSelector } from "../redux-store/CustomReduxHooks";

const usePageMessages = (cmsKey: string) => {
  const cmsData = useAppSelector((st) => st.CmsSlice.CmsPageMessagesData);

  const pageVariableData = useMemo(() => {
    if (!cmsData) return null;
    return cmsData.find((i) => i.attributes.key === cmsKey) ?? null;
  }, [cmsData, cmsKey]);

  return pageVariableData;
};

export default usePageMessages;

const useHlSuccessMessages = (cmsKey: string) => {
  const cmsData = useAppSelector((st) => st.CmsSlice.CmsHlSuccessMEssages);

  const pageVariableData = useMemo(() => {
    if (!cmsData) return null;
    return cmsData.find((i) => i.attributes.key === cmsKey) ?? null;
  }, [cmsData, cmsKey]);

  return pageVariableData;
};

export { useHlSuccessMessages };
